import { Anchor, Text } from '@mantine/core';
import { Condition } from '@medplum/fhirtypes';
import { FC } from 'react';

const GET_ORHPA_PAGE =
  'https://www.orpha.net/consor/cgi-bin/OC_Exp.php?Expert=';
const GET_OMIM_PAGE = 'https://omim.org/entry/';

export interface ExternalCodeProps {
  readonly condition: Condition;
  readonly system: 'omim' | 'orpha';
}

export const ExternalCode: FC<ExternalCodeProps> = ({ condition, system }) => {
  const systemMap: Record<string, { url: string; label: string }> = {
    omim: { url: GET_OMIM_PAGE, label: 'OMIM' },
    orpha: {
      url: GET_ORHPA_PAGE,
      label: 'ORPHA',
    },
  };

  const systemUrl = systemMap[system].url;
  const label = systemMap[system].label;
  const coding = condition.code?.coding?.find((c) =>
    c.system?.includes(system)
  );

  return (
    <Text fz="xs" c="dimmed">
      {label}:{' '}
      {coding?.code ? (
        <Anchor
          href={`${systemUrl}${coding.code}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {coding.code}
        </Anchor>
      ) : (
        '-'
      )}
    </Text>
  );
};
